import defineMessages from "../../../../common/helpers/defineMessages";

const messages = defineMessages({
    choose: {
        id: "select.choose",
    },
    delete: {
        id: "select.delete",
    },
    modify: {
        id: "general.modify",
    },
    typeahead: {
        id: "select.typeahead.placeholder",
    },
    noResults: {
        id: "select.typeahead.noResults",
    },
});

export default messages;
